import * as React from "react";
import { cn } from "@/lib/utils";

// Text input + field label, copied from careers.co.jp's ui/input.tsx
// (the pill/search variant and Textarea were dropped — this site has only
// two small forms: admin login and "new invitation").

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-9 w-full rounded-md border border-border bg-surface px-3.5 text-[14px] text-text placeholder:text-text-3",
        "focus:outline-2 focus:outline-brand-500 focus:outline focus:outline-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({
  className,
  ...props
}) => (
  <label
    className={cn(
      "block text-[11px] font-semibold uppercase tracking-wide text-text-2 mb-1.5",
      className,
    )}
    {...props}
  />
);
